<template>
    <div>
        <b-tab title="Tab 5">
            <b-card-text>
                <h2>FORMAZIONE</h2>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>RSPP Datore di lavoro</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.rspp_datore_evidenze"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Rischio basso: 16h<br>
                            Rischio medio: 32h<br>
                            Rischio alto: 48h
                        </label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>RSPP esterno</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Verifica attestato</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.rspp_esterno_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label></label>
                    </div>
                    <div class="form-group col-md-3">
                        <label> </label>
                    </div>
                </div>

                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Addetti antincendio</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.addetti_antincedio_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Rischio basso: 4h<br>
                                Rischio medio: 8h<br>
                                Rischio alto: 12h
                        </label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Preposti</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>3 anni*</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.preposti_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Nomina obbligatoria</label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Dirigenti</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.dirigenti_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Carrelli elevatori</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.carrelli_elevatori_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label> modulo teoria: 8h<br>
                                modulo pratica: 4h
                        </label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Gru (vari tipi)</label>
                    </div>
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.gru_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno<br>Vedi allegato</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label></label>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Formazione lavoratori</label>
                    </div>
                    
                    <div class="form-group col-md-2">
                        <label>Sempre valido</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.formazione_lavoratori_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Per tutti i rischi: 4h</label>
                    </div>
                </div>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                    </div>
                    
                    <div class="form-group col-md-3">
                        <label for="formazione_lavoratori_formati">Lavoratori formati n.</label>
                        <input type="number" class="form-control" v-model="formazione.formazione_lavoratori_formati">
                    </div>
                    <div class="form-group col-md-3">
                        <label for="formazione_lavoratori_formare">Lavoratori da formare n.</label>
                        <input type="number" class="form-control" v-model="formazione.ormazione_lavoratori_formare">
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
                <hr>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                        <label>Principali corsi:<br>Rischi specifici</label>
                    </div>
                    
                    <div class="form-group col-md-2">
                        <label>5 anni</label>
                    </div>
                    <div class="form-group col-md-2">
                        <div class="form-row justify-content-md-center">
                            <label class="label-switch">Evidenza</label>
                        </div>
                        <div class="form-row justify-content-md-center">
                            <label class="switch">
                                <input type="checkbox" class="form-control" v-model="formazione.rischi_evidenze_formazione"><span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-group col-md-2">
                        <label>Mese e anno<br>Vedi allegato</label>
                    </div>
                    <div class="form-group col-md-3">
                        <label>Rischio basso: 16h<br>
                                Rischio medio: 32h<br>
                                Rischio alto: 48h
                        </label>
                    </div>
                </div>
                <div class="form-row justify-content-center">
                    <div class="form-group col-md-3">
                    </div>
                    
                    <div class="form-group col-md-3">
                        <label for="rischio_lavoratori_formati">Lavoratori formati n.</label>
                        <input type="number" class="form-control" v-model="formazione.rischio_lavoratori_formati">
                    </div>
                    <div class="form-group col-md-3">
                        <label for="rischio_lavoratori_formare">Lavoratori da formare n.</label>
                        <input type="number" class="form-control" v-model="formazione.rischio_lavoratori_formare">
                    </div>
                    <div class="form-group col-md-3"></div>
                </div>
            </b-card-text>
        </b-tab>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->
        
    </div>
</template>
<script>
// import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    components: {
        // Card
    },

    data() {
        return {
            formazione: {},
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        formazioneValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addFormazioneValori() {
            this.formazione = Object.assign({}, this.formazioneValori);
        },

    },
    created() {
        this.addFormazioneValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
